import { Icon } from "semantic-ui-react";

export const EmptyChartMessage = ({ message, loading = false }) => (
  <div
    style={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      color: "#9e9e9e",
      padding: "16px",
    }}
  >
        <Icon name={loading ? "spinner" : "chart pie"} loading={loading} size="big" />
    <span >
      {message}
    </span>
  </div>
);

